import React from 'react'
import clsx from 'clsx'
import { pick } from 'lodash-es'
import { Tab } from '@ow/comps'
import { DittoProvider } from '@ow/ditto-core'
import {
  DetailStoreProvider,
  TbViewProvider,
  useProjectStore,
  useFetchRemoteData,
} from '@vt/hooks'
import styled from '@emotion/styled'
import { getQuery } from '@vt/utils'
import Attribute from './attribute'
import List from './list'
import BindUser from './bindUsers'
import BindStandard from './bindStandard'
import Create from './binding/createBind'
import useAreaStore from './areaStore'
import Map from './map'
import Massif from './massif'
import { useTabVisible } from './hooks/tab'

const StyledTab = styled(Tab)`
  height: 100%;
  .rc-tabs-content {
    height: 100%;
  }
`

const Detail = function ({ title, type, refreshTree }) {
  const fetchRemoteData = useFetchRemoteData()
  const appId = useProjectStore((state) => state.appId)
  const { vid } = getQuery()

  const { isCreateAreaBind } = useAreaStore((state) =>
    pick(state, ['isCreateAreaBind'])
  )

  const { tabRender, clickedId, areaBindUserTbId } = useTabVisible(title)

  return (
    <div className="flex flex-col gap-2 relative h-full">
      {isCreateAreaBind && <Create desc="点位" />}
      <div
        className={clsx('p-4 h-full bg-white', isCreateAreaBind && 'hidden')}
      >
        <StyledTab destroyInactiveTabPane>
          {tabRender(
            'attribute',
            <DittoProvider tbId={type} onFetchRemoteData={fetchRemoteData}>
              <DetailStoreProvider>
                <Attribute title={title} clickedId={clickedId} type={type} />
              </DetailStoreProvider>
            </DittoProvider>
          )}
          {tabRender(
            'list',
            <DittoProvider tbId={type} onFetchRemoteData={fetchRemoteData}>
              <TbViewProvider appId={appId} tbId={type} vid={vid}>
                <List clickedId={clickedId} refreshTree={refreshTree} />
              </TbViewProvider>
            </DittoProvider>
          )}
          {tabRender('user', <BindUser areaBindUserTbId={areaBindUserTbId} />)}
          {tabRender('standard', <BindStandard />)}
          {tabRender('geo', <Map />)}
          {tabRender('massif', <Massif />)}
        </StyledTab>
      </div>
    </div>
  )
}

export default Detail
